<template>
  <div>
    <el-table v-bind="mergedProps" v-on="$listeners">
      <slot></slot>
    </el-table>
    <div class="text-center" style="cursor: pointer;">
      <br/>
      <el-pagination
        :hide-on-single-page="true"
        @current-change="prikaziStran"
        :page-size="rowsPerPage"
        layout="prev, pager, next"
        :total="data !== null ? data.length : 0"
        :current-page.sync="currentPage"
        small>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {Table} from 'element-ui'

export default {
  name: 'T2Table',
  components: {
    [Table.name]: Table
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    rowsPerPage: {
      type: Number,
      default: 10
    },
    preloadPage: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      currentPage: this.preloadPage
    }
  },
  computed: {
    mergedProps () {
      let out = {...this.$props, ...this.$attrs}
      out.data = this.tableData

      return out
    },
    tableData () {
      let start = (this.currentPage - 1) * this.rowsPerPage
      return this.data.slice(start, start + this.rowsPerPage)
    }
  },
  methods: {
    prikaziStran (stran) {
      this.currentPage = stran
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/T2Table.vue